import type { SxProps, Theme } from '@mui/material/styles';

/** Sentinel id for flow-level perform expansion (start-of-flow row) in narrow Control tab */
export const FLOW_CONTROL_PERFORM_EXPAND_FLOW = '__flow_control_perform_flow__';

/**
 * Wrapper sx for inline PerformMiddleSection under the slot list: minWidth 0 + full width so
 * stacked Stages/Media (xs column) does not blow out flex/scroll; merge `mx` (0 vs -1) per call site.
 */
export const flowControlInlinePerformMiddleWrapperSx: SxProps<Theme> = {
  px: 0,
  pb: 0,
  m: 0,
  minWidth: 0,
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
};
